<footer class="footer">
  <div class="container">
    <div class="footer-content">
      <!-- Left: Contact -->
      <div class="col contact-col">
        <!-- <h4 class="footer-label">LEAGUE CITY YACHT SALES</h4> -->
        <p>
          <span class="footer-label" style="white-space: nowrap;">LEAGUE CITY YACHT SALES</span> <br>
          <!-- {{ mainAddress()?.addressLine1 }}<br /> -->
          {{ mainAddress()?.addressLine2 }}<br />
          {{ mainAddress()?.city }}, {{ mainAddress()?.state }} {{ mainAddress()?.zipCode }}
          {{ mainAddress()?.country }}
        </p>
        <br />
        <div style="display: flex; gap: 5px; margin-bottom: 16px;">
          <span style="white-space: nowrap;">Contact :</span>
          <div>
            {{ mainAddress()?.phone }}
            <!-- <br />+1 713-245-6662 -->
          </div>
        </div>
        <p>
          <a [href]="mainAddress()?.whatsapp" aria-label="Whatsapp" target="_blank">
            <i class="fab fa-whatsapp" style="color: #25d366; width: 20px"></i> WhatsApp
          </a>
        </p>
      </div>

      <!-- Center: Brand -->
      <div class="col brand-col">
        <div class="logo-wrapper">
          <!-- Using the official refined logo -->
          <img src="/lcys-logo-light-blue.svg" alt="LCYS Logo" class="footer-logo"
            onerror="this.src = '/lcys-logo-light-blue.png'" />
        </div>
        <p class="tagline">
          Building the Finest Yachting Experience
        </p>
        <p class="tagline">
          One Deal at a Time.
        </p>
      </div>

      <!-- Right: Socials -->
      <div class="col social-col">
        <div class="social-wrapper">
          <h4 class="footer-label">Follow Us</h4>
          <div class="social-links">
            <a [href]="facebookUrl()" aria-label="Facebook" target="_blank">
              <span class="icon">f</span> Facebook
            </a>
            <a [href]="instagramUrl()" aria-label="Instagram" target="_blank">
              <span class="icon">i</span> Instagram
            </a>
            <a [href]="twitterUrl()" aria-label="Twitter" target="_blank">
              <span class="icon">x</span>X
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <p>&copy; 2026 League City Yacht Sales. All rights reserved.</p>
      @if (analytics.configured) {
        <button type="button" (click)="analytics.preferenceOpen.set(true)"
          style="background: none; border: 0; color: inherit; text-decoration: underline; cursor: pointer; font: inherit;">
          Analytics preferences
        </button>
      }
    </div>
  </div>
</footer>
